export default "__VITE_ASSET__CZb7WPeE__"